/**
 * Auth Service
 *
 * API service for authentication-related endpoints.
 */

import { api } from '../../../shared/utils/api';
import type {
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  RefreshTokenResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
} from '../types/auth.types';

// Production uses same-origin relative paths (see shared/utils/api.ts).
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || (import.meta.env.PROD ? '' : 'http://localhost:3000');

/**
 * Authentication API service
 */
export const authService = {
  /**
   * Login with employee ID and password
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    return api.post<LoginResponse>(`${API_BASE_URL}/api/v1/auth/login`, credentials);
  },

  /**
   * Logout and invalidate refresh token
   */
  async logout(): Promise<LogoutResponse> {
    return api.post<LogoutResponse>(`${API_BASE_URL}/api/v1/auth/logout`, {});
  },

  /**
   * Refresh access token using refresh token cookie
   */
  async refreshToken(): Promise<RefreshTokenResponse> {
    return api.post<RefreshTokenResponse>(`${API_BASE_URL}/api/v1/auth/refresh`, {});
  },

  /**
   * Change password for a specific user
   */
  async changePassword(userId: number, payload: ChangePasswordRequest): Promise<ChangePasswordResponse> {
    return api.put<ChangePasswordResponse>(`${API_BASE_URL}/api/v1/users/${userId}/password`, payload);
  },
};
